<div class="auth-wrapper">
	<div class="auth-content">
		<div class="card-login">
			<form [formGroup]="form">
				<div class="form-container">
					<div class="form-card">
						<div class="card-body">
							<div class="brand-section">
								<div class="logo">
									<img src="assets/images/Logo.png" alt="Synergy Portal Logo" class="brand-logo">
								</div>
								<div class="logo-container">
									<h1 class="brand-title"> Synergy Portal</h1>
								</div>
							</div>
							<div *ngIf="!isReset" class="reset-form-section">
								<h4 class="form-title">Reset Password</h4>

								<div class="form-group">
									<label class="form-label" for="Password">Password</label>
									<input type="password" class="form-input" id="Password"
										placeholder="Enter your new password" formControlName="newPassword">
									<div *ngIf="getFormControls.newPassword.touched && getFormControls.newPassword.errors"
										class="error-message">
										<div *ngIf="getFormControls.newPassword.errors.required">Password is required
										</div>
									</div>
								</div>

								<button class="submit-button" [disabled]="!form.valid || !showBtn" (click)="reset()">
									<div *ngIf="!showBtn" class="spinner-container">
										<div class="spinner" role="status">
											<span class="sr-only">Loading...</span>
										</div>
									</div>
									<div *ngIf="showBtn">Submit</div>
								</button>
							</div>

							<div class="success-section" *ngIf="isReset">
								<p class="success-message">Password has been reset successfully, please sign in</p>
								<button class="signin-button" (click)="toLogin()">
									Sign In
								</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>